import React from 'react';

const ArrowRight = (props) => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12.8787 11.0001H0V8.00011H12.8787L7.93934 3.06077L10.0607 0.939453L18.6213 9.50011L10.0607 18.0608L7.93934 15.9395L12.8787 11.0001Z" fill={props.fill ? props.fill : '#333'} />
    </svg>
);
export default ArrowRight;
